"use client";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/** Android hardware back: navigate back or minimize app at root. */
export function CapacitorBackButton() {
  const navigate = useNavigate();

  useEffect(() => {
    let remove: (() => void) | undefined;

    void (async () => {
      const { Capacitor } = await import("@capacitor/core");
      if (!Capacitor.isNativePlatform()) {
        return;
      }

      const { App } = await import("@capacitor/app");
      const handle = await App.addListener("backButton", ({ canGoBack }) => {
        if (canGoBack) {
          window.history.back();
          return;
        }
        const hash = window.location.hash.replace(/^#\/?/, "");
        const atRoot = hash === "" || hash === "dashboard" || hash === "login";
        if (atRoot) {
          void App.minimizeApp();
        } else {
          navigate(-1);
        }
      });
      remove = () => {
        void handle.remove();
      };
    })();

    return () => {
      remove?.();
    };
  }, [navigate]);

  return null;
}
